import type { UsersListFilter } from '../../../../domain/users/repository';

/**
 * The tab id surfaced in the role/campaign filter strip. Mutually exclusive
 * with the others — `campaign` requires a campaign id to translate into a
 * concrete `UsersListFilter`, so the viewmodel keeps the selected id in a
 * separate slot and ignores it when the active tab isn't `campaign`.
 */
export type UsersFilterTab = 'all' | 'admins' | 'reviewers' | 'campaign';

export interface UsersFilterTabSpec {
  id: UsersFilterTab;
  label: string;
}

export const USERS_FILTER_TABS: UsersFilterTabSpec[] = [
  { id: 'all', label: 'All' },
  { id: 'admins', label: 'Admins' },
  { id: 'reviewers', label: 'Reviewers' },
  { id: 'campaign', label: 'Campaign' },
];

/**
 * Translate the UI selection into the shape `fetchUsersPage` / `countUsers`
 * expect. Returns `null` when the user picked the `campaign` tab without
 * choosing a campaign yet — callers should defer the fetch in that case
 * rather than silently fall back to "all".
 */
export function buildUsersListFilter(
  tab: UsersFilterTab,
  campaignId: string | null,
): UsersListFilter | null {
  switch (tab) {
    case 'all':
      return { kind: 'all' };
    case 'admins':
      return { kind: 'admins' };
    case 'reviewers':
      return { kind: 'reviewers' };
    case 'campaign':
      if (!campaignId) return null;
      return { kind: 'campaign', campaignId };
  }
}
